"use client"

import { FormEvent, useEffect, useRef, useState } from 'react'
import { toast } from 'react-toastify'
import { novoTicketSite, enviarMensagem } from '../../services/bot'
import { criarSocket } from "../../lib/socket"
import { mensagemResposta } from '../../interfaces/chat'
import { atualizarMsgLidaSite, buscarChat } from '../../services/chat'
import { telefoneMascara, criptografarDado, descriptografarDado } from '../../helpers'
import { Button } from '../styles'
import { Socket } from 'socket.io-client';
import iconeHg from '../../assets/img/iconeHg.jpeg'
import zaiIcone from '../../assets/svg/zai-icone.svg'
import usuarioImg from '../../assets/img/usuario.png'
import './chat.css'

export default function Chat() {
    const [ticket, setTicket] = useState<string | null>(null)
    const [destinatario, setDestinatario] = useState('')
    const [telefone, setTelefone] = useState('')
    const [chat, setChat] = useState(false)
    const [msg, setMsg] = useState('')
    const [msgInicial, setMsgInicial] = useState('')
    const [mensagens, setMensagens] = useState<mensagemResposta[]>([])

    const idOrganizacao = process.env.REACT_APP_ORGANIZACAO_HG

    const socketRef = useRef<Socket>()
    const chatRef = useRef<HTMLDivElement>(null)
    const [pagina, setPagina] = useState(1)
    const [carregando, setCarregando] = useState(false)
    const [temMais, setTemMais] = useState(true)

    const telefoneChange = (e: any) => {

        const { value } = e.target

        setTelefone(telefoneMascara(value))
        return
    }

    const iniciarAtendimento = async (e: FormEvent) => {

        e.preventDefault()

        try {

            const idConexao = Number(process.env.REACT_APP_CONEXAO_SITE)

            if (!idConexao) return toast.warning('Credencias não Validadas. Tente novamente mais tarde')

            const payload = {
                idConexao,
                idDestinatario: telefone,
                titulo: destinatario,
                telefone,
                msg: msgInicial,
                canal: 'Site',
                classificacao: "site"
            }

            const resposta = await novoTicketSite(payload)

            if (resposta.status === 201) {
                setTicket(resposta.data.id.toString())
                localStorage.setItem('ticketZai', criptografarDado(resposta.data.id.toString()))
                return
            }

        } catch (error: any) {

            if (error.status === 404) {
                return toast.error('Não há Conexões Disponiveis.')
            }

            if (error.status === 429) {
                return toast.error('Consumo Indevido. Tente Novamente em alguns instantes')
            }

            return toast.error('Falha ao Processar a sua Solicitação')

        }
    }

    const enviarMsg = async (e: FormEvent) => {

        e.preventDefault()

        if (!ticket) return
        if (!msg.trim()) return

        try {

            const formData = new FormData()
            formData.append("msg", msg)

            await enviarMensagem(criptografarDado(ticket.toString()), formData)
            setMsg("")

            return

        } catch {

            toast.error("Erro ao enviar Mensagem.")
            return
        }
    }

    const handleScroll = () => {
        const elemento = chatRef.current
        if (!elemento || !temMais) return

        if (!socketRef.current || !ticket) return

        const chegouNoTopo = Math.abs(elemento.scrollTop) >= elemento.scrollHeight - elemento.clientHeight - 50

        if (chegouNoTopo && !carregando) {
            setCarregando(true)

            const proximaPagina = pagina + 1

            socketRef.current.emit("listarMsgTicket", {
                idChat: ticket,
                pagina: proximaPagina,
            })

            setPagina(proximaPagina)
        }
    }

    useEffect(() => {
        const verificarTicket = async () => {
            try {
                const ticket = localStorage.getItem('ticketZai')
                if (!ticket) return
                const resposta = await buscarChat(ticket)

                if (resposta.data.situacao === "Finalizado") {
                    localStorage.removeItem('ticketZai');
                    setTicket(null);
                } else {
                    setTicket(descriptografarDado(ticket))
                }
            } catch (error) {
                return console.log(error)
            }

        }
        verificarTicket()
    }, [])

    useEffect(() => {
        if (!ticket) return
        if (!idOrganizacao) {
            toast.error("Organização não encontrada.")
            return
        }

        const socket = criarSocket(idOrganizacao)
        socket.on("connect", () => {
            socketRef.current = socket
            socket.emit("iniciarChat", {
                sala: ticket
            })
            socket.emit("listarMsgTicket", {
                idChat: ticket
            })
        })

        socket.on("historicoChat", (mensagens) => {
            setMensagens(prev => [
                ...prev,
                ...mensagens,
            ])
            setCarregando(false)
            if (mensagens.length === 0) {
                setTemMais(false)
            }
        })

        socket.on("novaMsgChat", (msg) => {
            return setMensagens(prev => [msg, ...prev])
        })

        return () => {
            socket.emit("encerrarChat", ticket)
            socket.off("novaMsgChat")
            socket.disconnect()
        }

    }, [ticket, idOrganizacao])

    useEffect(() => {
        const atualizarMsgNaoLidas = async () => {
            if (!ticket) return
            try {
                await atualizarMsgLidaSite(criptografarDado(ticket))
            } catch {
                toast.error("Erro ao marcar Mensagem como lida.")
            }
        }
        atualizarMsgNaoLidas()
    }, [])

    return (
        <aside className='containerChat'>
            <section title='Minizar Chat' className='contentHeader' onClick={() => setChat(!chat)}>
                <img src={iconeHg} alt='Logo Hg Consultoria' title='Fale Conosco' />
                {chat && <p title='Fale Conosco'>Hg Consultoria</p>}
            </section>

            {!ticket && chat && <form className='formNovoTicket' onSubmit={iniciarAtendimento}>
                <input
                    type="text"
                    placeholder='Nome e Sobrenome'
                    value={destinatario}
                    onChange={(e) => setDestinatario(e.target.value)}
                    required
                />
                <input
                    type="text"
                    placeholder='Telefone'
                    value={telefone}
                    onChange={telefoneChange}
                    maxLength={18}
                    minLength={18}
                    required
                />

                <textarea
                    placeholder='Digite sua mensagem'
                    value={msgInicial}
                    onChange={(e) => setMsgInicial(e.target.value)}
                    rows={8}
                    required
                />

                <Button isLoading={false} cor="continuar" type='submit' isCancelar={false}>Iniciar Atendimento</Button>
            </form>}
            {chat && ticket && <div className='containerMsg'>
                <section className='contentMsg' ref={chatRef} onScroll={handleScroll}>
                    {mensagens.filter((mensagem) => mensagem.privada !== true).map((mensagem, index) => {
                        const atendente = mensagem.idUsuarioCreate
                        return (
                            <span className={atendente ? `${'msg'} ${'msgRecebida'}` : `${'msg'}`} key={index}>
                                {mensagem.mediaType?.startsWith("audio") ? (
                                    <audio controls src={mensagem.mediaUrl as string} className='audio_box' />
                                ) : mensagem.mediaType?.startsWith("image") ? (
                                    <a href={mensagem.mediaUrl as string} target="_blank" rel="noopener noreferrer">
                                        <img
                                            src={mensagem.mediaUrl as string}
                                            alt="Imagem enviada"
                                            width={200}
                                            height={200}
                                            className='imagem_enviada'
                                        />
                                    </a>
                                ) : mensagem.mediaType?.startsWith("video") ? (
                                    <video controls width={300} className='video_box'>
                                        <source src={mensagem.mediaUrl as string} type={mensagem.mediaType} />
                                        Seu navegador não suporta vídeos.
                                    </video>
                                ) : mensagem.mediaType?.startsWith("application") ? (
                                    mensagem.mediaUrl && (
                                        <a
                                            href={mensagem.mediaUrl}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className='doc_link'
                                        >
                                            📄 Abrir documento
                                        </a>
                                    )
                                ) : (
                                    <p>{mensagem.msg.split("\n").map((linha, i) => {
                                        const urlRegex = /(https?:\/\/[^\s]+)/g;
                                        const partes = linha.split(urlRegex);

                                        return (
                                            <span key={i}>
                                                {partes.map((parte, j) =>
                                                    urlRegex.test(parte) ? (
                                                        <a key={j} href={parte} target="_blank" rel="noopener noreferrer">
                                                            {parte}
                                                        </a>
                                                    ) : (
                                                        parte
                                                    )
                                                )}
                                                <br />
                                            </span>
                                        );
                                    })}</p>
                                )}

                                <img className='avatarZaiIcone' src={atendente ? zaiIcone : usuarioImg} alt='Logo do Zai' title='Fale Conosco' width={25} height={25} />
                            </span>
                        )
                    })}
                </section>
                <section className='contentEnviarMsg'>
                    <form onSubmit={enviarMsg}>
                        <input
                            type="text"
                            placeholder='Digite sua mensagem'
                            value={msg}
                            onChange={(e) => setMsg(e.target.value)}
                            required
                        />
                    </form>
                </section>
            </div>}
        </aside>
    )
}